import React from 'react';

import { FormattedMessage } from 'react-intl';

import { Button } from '@xingternal/button';

import {
  Container,
  Img,
  ImgMobileContainer,
  Hero,
  BodyCopy,
  ImageDesktopContainer,
} from './ContentSection.style';

const ContentSection = ({
  imageOnTheRight,
  imageSrc,
  imageAltTranslationId,
  headlineTranslationId,
  headlineTranslationDefaultMessage,
  textTranslationId,
  textTranslationDefaultMessage,
  buttonTextTranslationId,
  link,
  scrollToId,
}) => {
  return (
    <Container {...(scrollToId && { id: scrollToId })}>
      <div>
        <Hero forwardedAs="h2" size="small" sizeOnConfined="medium">
          <FormattedMessage
            id={headlineTranslationId}
            {...(headlineTranslationDefaultMessage && {
              defaultMessage: headlineTranslationDefaultMessage,
            })}
          />
        </Hero>
        <ImgMobileContainer>
          <FormattedMessage id={imageAltTranslationId}>
            {text => <Img src={imageSrc} alt={text} loading="lazy" />}
          </FormattedMessage>
        </ImgMobileContainer>
        <BodyCopy>
          <FormattedMessage
            id={textTranslationId}
            {...(textTranslationDefaultMessage && {
              defaultMessage: textTranslationDefaultMessage,
            })}
          />
        </BodyCopy>
        {link && buttonTextTranslationId ? (
          <Button
            href={link}
            variant="primary"
            size="large"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id={buttonTextTranslationId} />
          </Button>
        ) : null}
      </div>
      <ImageDesktopContainer imageOnTheRight={imageOnTheRight}>
        <FormattedMessage id={imageAltTranslationId}>
          {text => <Img src={imageSrc} alt={text} loading="lazy" />}
        </FormattedMessage>
      </ImageDesktopContainer>
    </Container>
  );
};
export default ContentSection;
